<script setup lang="ts">
import {
  Employee as EmployeeData,
  MediaImageFragment,
  ParagraphOpenJobContactItem,
  ParagraphOpenJobContacts,
} from '~/api/graphql/generated'
import { OpenJobContact } from '~/views/cms/openJob/components/OpenJobContactPerson.vue'
import { Employee } from '~/views/cms/components/EmployeeSingle.vue'
import sanitizeHtml from 'sanitize-html'

const props = defineProps<{
  entity: ParagraphOpenJobContacts
}>()

const items: ComputedRef<OpenJobContact[]> = computed(
  () =>
    props.entity.fieldItems
      ?.filter(Boolean)
      .map((item) => item.entity as ParagraphOpenJobContactItem)
      .filter(Boolean)
      .filter((entity) => entity.fieldEmployee?.entity !== null)
      .map((entity) => {
        const employeeData = entity.fieldEmployee?.entity as EmployeeData
        const employee: Employee = {
          image: employeeData?.fieldImage?.entity as MediaImageFragment,
          name: `${
            employeeData?.fieldAcademicTitle ?? ''
          } ${employeeData?.fieldFirstName} ${employeeData?.fieldLastName}`,
          position: sanitizeHtml(employeeData.fieldPosition?.[0]?.entity?.fieldWorkTitle ?? ''),
          phone: employeeData.fieldPhone ? employeeData.fieldPhone : '',
        }

        return {
          title: entity.fieldTitle || '',
          tagline: entity.fieldSubline || '',
          link: {
            url: entity.fieldLink?.url?.path || '',
            text: entity.fieldLink?.title || '',
            target: entity.fieldLink?.options.attributes.target || '_self',
          },
          employee,
        }
      }) || [],
)
</script>

<template>
  <Section v-animate="{ animation: 'vertical-reveal' }" large>
    <ul class="items cul">
      <li v-for="item in items" :key="item.employee.name">
        <OpenJobContactPerson :data="item" />
      </li>
    </ul>
  </Section>
</template>

<style lang="scss" scoped>
.items {
  display: grid;
  grid-template-columns: 100%;
  gap: 6px;
  @include breakpoint(ts) {
    gap: var(--gap);
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
</style>
